import React from "react";
import "./SuccessStory.css";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";

const SuccessStory = ({ headingLevel = "h2" }) => {
  const stories = [
    {
      title: "Staffing Success",
      description:
        "Placed specialist engineers into roles a client had struggled to fill, so a stalled programme could move again.",
    },

    {
      title: "CAD Automation",
      description:
        "Automated the repetitive steps in a design release process, freeing engineers for the work that needs judgement.",
    },
    {
      title: "Problem Solving",
      description:
        "Resolved bottlenecks in a manufacturing process by automating the checks that were holding up release.",
    },
    {
      title: "AI in CAD",
      description:
        "Brought AI-assisted checking into a CAD workflow so design errors surface before approval, not after.",
    },
    {
      title: "Niche Resources",
      description:
        "Supplied hard-to-find domain specialists so a complex programme could be delivered without compromising on quality.",
    },
    {
      title: "Vision for Quality",
      description:
        "Built computer vision inspection into a production line so defects are caught consistently rather than by sampling.",
    },
    {
      title: "Private AI",
      description:
        "Developed a custom AI model that improved diagnostic consistency and removed manual processing steps.",
    },
    {
      title: "3D Search",
      description:
        "Gave a design team the ability to search existing parts by shape, so proven designs get reused instead of rebuilt.",
    },
    {
      title: "Object Detection",
      description:
        "Introduced automated object detection so routine manual checks no longer depend on someone spotting them.",
    },
    {
      title: "ISO Certified",
      description:
        "Helped a manufacturing client obtain ISO certification, boosting their market credibility and aligning with global standards.",
    },
    {
      title: "Team Growth",
      description:
        "Grew an in-house team of CAD, PLM and AI specialists who work on your systems, not around them.",
    },
  ];

  const responsive = {
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 3,
      slidesToSlide: 1,
    },
    tablet: {
      breakpoint: { max: 1024, min: 766 },
      items: 2,
      slidesToSlide: 1,
    },
    mobile: {
      breakpoint: { max: 766, min: 0 },
      items: 1,
      slidesToSlide: 1,
    },
  };

  const CustomLeftArrow = ({ onClick }) => {
    return (
      <button className="custom-arrow left-arrow" onClick={onClick}>
        <ArrowBackIosIcon />
      </button>
    );
  };

  const CustomRightArrow = ({ onClick }) => {
    return (
      <button className="custom-arrow right-arrow" onClick={onClick}>
        <ArrowForwardIosIcon />
      </button>
    );
  };

  // This renders both as the /success page and as a section of the home page.
  // As a standalone page it needs to be the h1; on the home page the h1 belongs
  // to the page itself, so it stays an h2.
  const Heading = headingLevel;

  return (
    <div className="success-stories-container">
      <div className="success-story-container">
        <Heading className="success-story-heading">SUCCESS STORIES</Heading>
        <Carousel
          swipeable={true}
          draggable={true}
          showDots={true}
          responsive={responsive}
          ssr={true}
          infinite={true}
          autoPlay={true}
          autoPlaySpeed={2000}
          keyBoardControl={true}
          customTransition="all 0.5s"
          transitionDuration={500}
          containerClass="carousel-container"
          removeArrowOnDeviceType={[]}
          dotListClass="custom-dot-list-style"
          itemClass="carousel-item-padding-40-px"
          customLeftArrow={<CustomLeftArrow />}
          customRightArrow={<CustomRightArrow />}
        >
          {stories.map((story, index) => (
            <div className="success-story" key={index}>
              <div className="success-story-content">
                <h3 className="success-story-title">{story.title}</h3>
                <p className="success-story-description">{story.description}</p>
              </div>
            </div>
          ))}
        </Carousel>
      </div>
    </div>
  );
};

export default SuccessStory;
